import { useEffect, useRef, useState } from 'react'
import { Link, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useUser } from 'contexts/UserContext'
import { completeMailOAuth, MailApiError } from 'services/mail'
import type { Mailbox } from 'services/mail'
import { isMailUuid } from 'utils/mailNavigation'
export default function MailOAuthCallbackPage() {
  const { user, loading } = useUser()
  const location = useLocation(), navigate = useNavigate()
  // Pure initializer: StrictMode may evaluate twice. Strip the URL in the effect.
  const [callback] = useState(() => {
    const params = new URLSearchParams(location.search)
    return { code: params.getAll('code').length === 1 ? params.get('code') : null, state: params.getAll('state').length === 1 ? params.get('state') : null, error: params.get('error') }
  })
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending')
  const [message, setMessage] = useState('Completamento collegamento…')
  const [mailbox, setMailbox] = useState<Mailbox | null>(null), [diagnostic, setDiagnostic] = useState('')
  const request = useRef<Promise<Mailbox> | null>(null)
  useEffect(() => {
    if (!loading && user) navigate('/mail/oauth/callback', { replace: true })
  }, [loading, user?.id])
  useEffect(() => {
    if (loading || !user) return
    let active = true
    if (callback.error || !callback.code || !callback.state) {
      setStatus('error'); setMessage(callback.error ? 'Consenso Gmail negato o interrotto. Puoi riprendere il collegamento dalla casella esistente.' : 'Parametri di collegamento mancanti. Riprendi il collegamento dalla casella esistente.')
      return
    }
    if (!request.current) request.current = completeMailOAuth(callback.code, callback.state)
    request.current.then(result => {
      if (!active) return
      if (!isMailUuid(result.id)) throw new Error('Casella restituita non valida.')
      setMailbox(result); setStatus('success'); setMessage('Account collegato')
    }).catch(e => { if (active) { setStatus('error'); setMessage('Collegamento non riuscito o scaduto. Riprendi il consenso dalla casella esistente.'); setDiagnostic(e instanceof MailApiError ? e.code : '') } })
    return () => { active = false }
  }, [loading, user?.id, callback])
  if (!loading && !user) return <Navigate to="/login" replace />
  return <main className="mx-auto max-w-lg p-8"><h1 className="text-2xl font-semibold">Collegamento Gmail</h1><p role={status === 'error' ? 'alert' : 'status'} className="my-4">{message}</p>
    {mailbox && <div className="flex flex-wrap gap-3"><Link className="underline" to={`/mail/inbox?mailbox=${mailbox.id}`}>Apri posta</Link><Link className="underline" to={`/mail/accounts?mailbox=${mailbox.id}`}>Gestisci casella</Link></div>}
    {diagnostic && <details><summary>Dettagli collegamento</summary><p>{diagnostic}</p></details>}
    {status !== 'pending' && <Link to="/mail/accounts" className="underline">Torna alle caselle</Link>}
  </main>
}
